import { compact } from '../../../../../helpers/compact';
import { toLinkFromProp } from '../../../fields/link';
import { toTextFromProp } from '../../../fields/text';

export const processFinancialFooter = (data) =>
  compact({
    firstContact: toLinkFromProp('firstContact', data),
    secondContact: toLinkFromProp('secondContact', data),
    contactEmail: toTextFromProp('contact_email', data),
    push: toLinkFromProp('push', data),
  });
